import { Liquid } from '@ant-design/charts'
import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { translate } from '../../../../../languages'
import { RootState } from '../../../../../stores'

const StyledTankRemainContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`

const StyledTankRemainTitle = styled.div`
  font-weight: bold;
  width: 100%;
  text-align: center;
`

type TankRemainVolumeComponentProps = {
  total: number
  remain: number
}

export const TankRemainVolumeComponent: React.FC<TankRemainVolumeComponentProps> =
  ({ total, remain }) => {
    const { language } = useSelector((state: RootState) => state.language)

    const [percent] = React.useState(remain / (total || 1))
    const color = React.useMemo(
      () => (percent <= 0.1 ? 'red' : percent >= 0.7 ? '#5af725' : '#f7b72f'),
      [percent]
    )

    const config = {
      percent: percent,
      outline: {
        border: 4,
        distance: 4,
        style: {
          stroke: color,
          strokeOpacity: 0.65,
        },
      },
      wave: { length: 128 },
      theme: { styleSheet: { brandColor: color } },
    }

    return (
      <StyledTankRemainContainer>
        <StyledTankRemainTitle>
          {translate('tank.remain', language)}
        </StyledTankRemainTitle>
        <Liquid {...config} style={{ width: '100%', height: '200px' }} />
      </StyledTankRemainContainer>
    )
  }
